<template>
  <router-link class="link-button" v-bind:to="link">
    {{ title }} ▶
  </router-link>
</template>

<script>
export default {
  props: ['link', 'title'],
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/modules/LinkButton.vue